// enables GUI access to mmm page for external clients
const MMMExternalCompanies: string[] = [
  "tinuititest",
  "aeropostale",
  "away",
  "becausemarket",
  "bonobos",
  "brooksbrothers",
  "bruntworkwear",
  "butcherbox",
  "culligan",
  "dsw",
  "eddiebauer",
  "equifax",
  "freedomcare",
  "impossiblefoods",
  "instacart",
  "joann",
  "leafguard",
  "liquidiv",
  "lucky",
  "maurices",
  "nautica",
  "nobull",
  "onceuponafarm",
  "petco",
  "poppi",
  "reverb",
  "rover",
  "saxx",
  "saxxca",
  "trugreen",
  "tula",
  "upside",
  "vici",
  "warbyparker",
];

export const shouldEnableMMMNavbarGui = (company: string): boolean => {
  if (MMMExternalCompanies.includes(company)) {
    return true;
  } else {
    return false;
  }
};
